// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","MenuItem":"bgb_a bhh_un bhh_cw bhh_a","MenuItem__Btn":"bgb_b bhh_z"};